(() => {
  const sliders = document.querySelectorAll(".sas-marquee-slider .swiper");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    if (slider.dataset.initialized === "true") return;

    const slides = slider.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    const columnsDesktop = parseFloat(slider.dataset.columnsDesktop) || 3;
    const columnsMobile = parseFloat(slider.dataset.columnsMobile) || 1;
    const spaceBetween = parseInt(slider.dataset.spaceBetween, 10) || 16;
    const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) || 12000;
    const autoplayEnabled = slider.dataset.autoplayEnabled === "true";
    const loopSetting = slider.dataset.loopEnabled === "true";
    const showArrows = slider.dataset.showArrows === "true";
    const showDots = slider.dataset.showDots === "true";
    const loopEnabled = loopSetting && slides.length > 1;
    const sectionId = slider.dataset.sectionId;
    const sliderSection = slider.closest(".sas-marquee-slider");
    const prevEl = showArrows
      ? sliderSection?.querySelector(`.swiper-button-prev-${sectionId}`)
      : null;
    const nextEl = showArrows
      ? sliderSection?.querySelector(`.swiper-button-next-${sectionId}`)
      : null;
    const paginationEl = showDots
      ? sliderSection?.querySelector(`.swiper-pagination-${sectionId}`)
      : null;
    const transitionSpeed = autoplayEnabled ? autoplaySpeed : 600;

    const swiperOptions = {
      loop: loopEnabled,
      slidesPerView: columnsMobile,
      spaceBetween,
      speed: transitionSpeed,
      autoplay: autoplayEnabled
        ? {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }
        : false,
      freeMode: autoplayEnabled
        ? {
            enabled: true,
            momentum: false,
          }
        : false,
      allowTouchMove: true,
      watchSlidesProgress: true,
      breakpoints: {
        750: {
          slidesPerView: columnsDesktop,
          spaceBetween,
        },
      },
    };

    if (prevEl && nextEl) {
      swiperOptions.navigation = {
        prevEl,
        nextEl,
      };
    }

    if (paginationEl) {
      swiperOptions.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    new Swiper(slider, swiperOptions);

    slider.dataset.initialized = "true";
  });
})();
